/**
 * File toc.js.
 * Handles open/close blog TOC on mobile.
 * Handles highlighting TOC item while scrolled to section.
 * handles overriding the anchor clicks with scrollIntoView
 */

//init
const sections = document.querySelectorAll('.heading.heading--h2-blog.header__custom--text');
const anchors = document.querySelectorAll('.header__anchor');

const tableOfContentsHeader = document.querySelector('.blog-template__eyebrow.copy--body-sm.blog-template__eyebrow--open');
const tableOfContentsWrapper = document.querySelector('.blog-template__toc');
const tableOfContentsView = document.querySelector('.blog-template__main-content--toc');
const tableOfContentsItems = [...document.querySelectorAll('.table-of-contents__item')];

const ctaWrapper = document.querySelector('.blog-template__cta-wrapper');

const { top: tableOfContentsMinTop, bottom: tableOfContentsBottom, height: tableOfContentsHeight } = tableOfContentsWrapper.getBoundingClientRect();
const { top: ctaWrapperTop, height: ctaWrapperHeight } = ctaWrapper.getBoundingClientRect();

const referenceAttribute = 'data-contents-index';

// half padding for managing nudging of list moving and how much the list should float away from the CTA
// this is more a desktop sizing value (since this functionality does not appear on mobile)
const HALF_PADDING = 30; 

let previousIndex = -1;

if (floatingDisclaimer != null) {
  ctaWrapper.style.bottom = `${floatingDisclaimer.getBoundingClientRect().height}px`;
}

// set the toggle for the mobile view of table of contents
tableOfContentsHeader.addEventListener('click', e => {
  e.target.classList.toggle('blog-template__eyebrow--closed');
  tableOfContentsWrapper.querySelector('.table-of-contents').classList.toggle('table-of-contents--closed');
});

// initialize the height of the TOC to prevent clipping with the CTA (creates a hugging effect)
tableOfContentsWrapper.style.height = `${(tableOfContentsHeight + ctaWrapperHeight) - (HALF_PADDING * 2)}px`;

// when we change sections (i.e., clicking the toc or scrolling) we change the active item to the index, and unset all others
const unsetActiveItems = currentIndex => {
  tableOfContentsItems.forEach((item, index) => {
    if (index === currentIndex) { return; }

    item.querySelector('a').classList.remove('active');
  })
}

// observe the title block to unset the actively highlighted item (which will most likely be the first TOC item)
const titleObserver = new IntersectionObserver(elements => {
  const queryElement = elements[0];

  if (queryElement.isIntersecting) {
    unsetActiveItems(-1);
  }
}, {
  rootMargin: "0px 0px 0px 0px",
  threshold: 1
});

titleObserver.observe(document.querySelector('.blog-template__title'));

// for each of the sections, both by the title and the section content itself,
// we want to figure out how we want to: 
// A) change the existing highlighted TOC item
// B) potentially shift the list up or down 
const sectionObserver = new IntersectionObserver(elements => {
  elements.forEach(e => {
    const index = Number(e.target.getAttribute(referenceAttribute));
    const tableOfContentsItem = tableOfContentsItems[index].querySelector('a');
    const height = tableOfContentsItems[index].getBoundingClientRect().height;

    // when the observed item finds itself in the desired viewing area,
    // and this is not the same item we last evaluated
    if (e.isIntersecting && index !== previousIndex) {
      // mark the TOC list item as active
      tableOfContentsItem.classList.add('active');
      
      // a rudimentary decision of when we decide to shift this list up and down
      if (index > tableOfContentsItems.length / 2) {
        // depth = how far we are clipping into the table of contents
        const depth = tableOfContentsView.getBoundingClientRect().bottom - ctaWrapper.getBoundingClientRect().top;

        // only shift the list if the list is clipping the CTA
        if (depth > 0) {
          const delta = (index - previousIndex) < 0 ? -1 : 1; // up or down scroll?
          const currentTop = tableOfContentsWrapper.getBoundingClientRect().top;
          const factor = (height + HALF_PADDING) * delta; // nudging distance

          tableOfContentsWrapper.style.top = `${currentTop - factor}px`; // apply it
        }
      } else {
        // when we are back to the first half of the list, remove our adjustments
        tableOfContentsWrapper.style.top = null; 
      }

      previousIndex = index;
      unsetActiveItems(index);
    }
  });
}, {
  rootMargin: '-150px 0px -750px 0px',
  threshold: 0
});

sections.forEach(section => {
  const itemIndex = tableOfContentsItems.findIndex(i => i.textContent === section.textContent);
  const sectionContent = document.querySelectorAll('.blog-template__content.copy--body')[itemIndex];

  if (itemIndex !== -1) {
    section.setAttribute(referenceAttribute, itemIndex);
    sectionObserver.observe(section);

    
    if (sectionContent != null) {
      sectionContent.setAttribute(referenceAttribute, itemIndex);
      sectionObserver.observe(sectionContent);
    }
    
  }
});

tableOfContentsItems.forEach((content, i) => {
  content.addEventListener('click', e => {
    e.preventDefault();
    anchors[i].scrollIntoView({ behavior: "smooth" })
  });
});
// end init
